export default {
  nextJob: 'Next job',
  plannedJobMetricsUnavailable: 'Metrics will be available once this job starts.',
  previousJob: 'Previous job',
  detailsTabs: {
    consumption: 'Consumption',
    events: 'Events',
    images: 'Images',
  },
};
